export default __webpack_public_path__ + "locales/sl/Settings.json?hash=82025652cadc15dc51470a09d79cd041";